export const SET_CURRENT = "CURRENCY/SET_CURRENT";
export const SET_DISABLE_SELECT = "CURRENCY/SET_DISABLE_SELECT";
